export const ACTION_MASS_VISIBLE = 'actionMassVisible';
export const ACTION_MASS_NON_VISIBLE = 'actionMassNonVisible';
